import { Injectable } from '@angular/core';
import { GeneralErrorService } from './general-error.service';

@Injectable()
export class SimpleGeneralErrorService implements GeneralErrorService {
    informUser(error: any) {
        alert('ERROR: ' + JSON.stringify(error, undefined, 2));
    }
}
